import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold" }, [
  /*#__PURE__*/_createTextVNode(" Payers "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger ms-1" }, "*")
], -1 /* HOISTED */)
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-row align-items-center mb-1 card p-2 w-100 overflow-auto"
}
const _hoisted_3 = { class: "form-group d-flex mb-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "me-2 mt-2" }, "Payer Status", -1 /* HOISTED */)
const _hoisted_5 = {
  class: "btn-group btn-group-toggle",
  "data-bs-toggle": "buttons"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  hidden: "",
  name: "is-current",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" All ")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Current ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  hidden: "",
  name: "is-current",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "form-group row form-inline mb-0 ms-3"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "mt-1 pe-0 col" }, "Payer Type", -1 /* HOISTED */)
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", { class: "text-capitalize" }, "Add Payer", -1 /* HOISTED */)
const _hoisted_16 = {
  key: 1,
  class: "text-center mt-1"
}
const _hoisted_17 = {
  id: "PatientPayor__Table",
  class: "table table-responsive-md border border-gray"
}
const _hoisted_18 = { class: "table-header" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Payer Type ")
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("th", null, "Payer", -1 /* HOISTED */)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", null, "Member ID", -1 /* HOISTED */)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", null, "Group Name", -1 /* HOISTED */)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", null, "Group ID", -1 /* HOISTED */)
const _hoisted_26 = { key: 2 }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Effective Date")
const _hoisted_28 = { key: 3 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions", -1 /* HOISTED */)
const _hoisted_30 = {
  key: 0,
  class: "table-empty"
}
const _hoisted_31 = ["colspan"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h3", null, "No Payers Found.", -1 /* HOISTED */)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 2,
  class: "table-error"
}
const _hoisted_37 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PayerForm = _resolveComponent("PayerForm")!
  const _component_SortableTh = _resolveComponent("SortableTh")!
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_PayerRow = _resolveComponent("PayerRow")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (!_ctx.isAddPayerRequested)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", {
                  class: _normalizeClass(`btn btn-outline-secondary font-size-xs ${_ctx.isCurrent ? '' : 'active'}`),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setIsCurrent(false)))
                }, _hoisted_8, 2 /* CLASS */),
                _createElementVNode("label", {
                  class: _normalizeClass(`btn btn-outline-secondary font-size-xs ${_ctx.isCurrent ? 'active' : ''}`),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setIsCurrent(true)))
                }, _hoisted_11, 2 /* CLASS */)
              ])
            ])
          ]),
          (!_ctx.isCurrent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select col",
                  name: "patient-payer-option",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedType) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patientPayerOptions, (patientPayerOption) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: patientPayerOption,
                      value: patientPayerOption
                    }, _toDisplayString(patientPayerOption), 9 /* TEXT, PROPS */, _hoisted_14))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, _ctx.selectedType]
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            class: "btn btn-sm btn-primary ms-auto",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openAddPayer()))
          }, "Add Payer")
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.isAddPayerRequested)
      ? (_openBlock(), _createElementBlock("section", {
          key: 1,
          class: _normalizeClass(`card px-lg-5 py-2 mb-2 animated w-100 ${_ctx.isAddPayerRequested ? 'faster fadeInDown' : 'slow fadeOutUp'}`)
        }, [
          _hoisted_15,
          (_ctx.newPatientPayer)
            ? (_openBlock(), _createBlock(_component_PayerForm, {
                key: 0,
                payer: _ctx.newPatientPayer,
                patientDetails: _ctx.patientDetails,
                "is-loading": _ctx.isAddPayerInProgress,
                "medicare-ids": _ctx.medicareIds,
                "is-add-form": true,
                "provider-id": _ctx.patientOptions.data.providerId,
                ref: "payerForm"
              }, null, 8 /* PROPS */, ["payer", "patientDetails", "is-loading", "medicare-ids", "provider-id"]))
            : _createCommentVNode("v-if", true),
          (!_ctx.isAddPayerInProgress)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-md",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveNewPayer()))
                }, "Add Payer"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary btn-md ms-2",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeAddPayer()))
                }, "Cancel")
              ]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_Pagination, {
      ref: "payersPagination",
      pageChanged: _ctx.pageChangedCallback,
      isLoading: _ctx.isLoading
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_17, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_18, [
              (_ctx.hasData)
                ? (_openBlock(), _createElementBlock("th", _hoisted_19, [
                    _createVNode(_component_SortableTh, {
                      "sort-by": _ctx.sortBy,
                      onSortByUpdated: _ctx.sortByUpdated,
                      "sort-order": _ctx.sortOrder,
                      onSortOrderUpdated: _ctx.sortOrderUpdated,
                      "sort-string": "type"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                  ]))
                : (_openBlock(), _createElementBlock("th", _hoisted_21, "Payer Type")),
              _hoisted_22,
              _hoisted_23,
              _hoisted_24,
              _hoisted_25,
              (_ctx.hasData)
                ? (_openBlock(), _createElementBlock("th", _hoisted_26, [
                    _createVNode(_component_SortableTh, {
                      "sort-by": _ctx.sortBy,
                      onSortByUpdated: _ctx.sortByUpdated,
                      "sort-order": _ctx.sortOrder,
                      onSortOrderUpdated: _ctx.sortOrderUpdated,
                      "sort-string": "effectiveDate"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                  ]))
                : (_openBlock(), _createElementBlock("th", _hoisted_28, "Effective Date")),
              _hoisted_29
            ])
          ]),
          _createElementVNode("tbody", null, [
            (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                  _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_33, 8 /* PROPS */, _hoisted_31)
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.isLoading)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.loadingCount, (i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: i,
                    class: "table-loading"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                      return (_openBlock(), _createElementBlock("td", { key: i }, _hoisted_35))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            (!_ctx.isLoading && _ctx.isError)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                  _createElementVNode("td", { colspan: _ctx.columns }, [
                    _createVNode(_component_ErrorMessageHandler, {
                      title: "Payers",
                      "try-again": _ctx.resetList
                    }, null, 8 /* PROPS */, ["try-again"])
                  ], 8 /* PROPS */, _hoisted_37)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          (!_ctx.isLoading && !_ctx.isError && _ctx.hasData)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.page.Items, (item) => {
                return (_openBlock(), _createBlock(_component_PayerRow, {
                  key: item.Id,
                  payer: item,
                  columns: _ctx.columns,
                  "payor-type-enum": _ctx.payorTypeEnum,
                  "medicare-ids": _ctx.medicareIds,
                  "reset-list": _ctx.resetList,
                  "update-patient-payer": _ctx.updatePatientPayer,
                  "delete-patient-payer": _ctx.deletePatientPayer
                }, null, 8 /* PROPS */, ["payer", "columns", "payor-type-enum", "medicare-ids", "reset-list", "update-patient-payer", "delete-patient-payer"]))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["pageChanged", "isLoading"])
  ], 64 /* STABLE_FRAGMENT */))
}